import type { Maybe } from '@adornis/base/utilTypes.js';
import type { AdornisMailer } from '@adornis/mails/server/mailer.js';

export function fillInEmpty(data: Array<{ year: number; week: number; total: number }>) {
  const registrationsOverTime = [] as Array<{ year: number; week: number; total: number }>;

  for (const { year, week, total } of data.reverse()) {
    const last = registrationsOverTime.at(-1);
    if (last) {
      const { year: lastYear, week: lastWeek } = last;
      if (year === lastYear) {
        // fill in empty
        for (let fillerWeek = lastWeek + 1; fillerWeek < week; fillerWeek++) {
          registrationsOverTime.push({ year, week: fillerWeek, total: 0 });
        }
      }
    }
    registrationsOverTime.push({ year, week, total });
  }

  return registrationsOverTime;
}

export function isDefined<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

export function at<Tarr extends Array<any>>(index: number) {
  return (arr: Tarr) => arr[index] as Tarr extends Array<infer T> ? T : never;
}

export function sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

let _mailer: AdornisMailer | null = null;

// ? This could be expanded to set mor internal state thats defined in the project scope. Rename this function "configure" or something then
export const setMailer = (mailer: AdornisMailer) => {
  _mailer = mailer;
};

export const getMailer = () => {
  if (!_mailer) throw new Error('no _mailer set!');
  return _mailer;
};

// mongo
export const lookupEntityById = (Entity: typeof MongoEntity, localField: string, name: string) => ({
  from: Entity._collectionName,
  localField,
  foreignField: '_id',
  as: name,
});

export const jsFun = (fn, ...args) => ({
  $function: {
    body: fn.toString(),
    args,
    lang: 'js',
  },
});

export const searchMatch = (fields: string[], search: Maybe<string>) =>
  search
    ? {
        $expr: {
          $or: fields.map(field => ({ $regexMatch: { input: '$' + field, regex: search, options: 'i' } })),
        },
      }
    : {};

export const withDefault = (value, def) => ({ $ifNull: [value, def] });
